import { axios } from 'lib'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { PaginatedResponse } from 'services/api/types'

type SaleType = {
  id: string
  description: string
}

const loadOrderSaleType = (): PaginatedResponse<SaleType> => {
  return axios.get(`orders/sale-types-by-user`)
}

export function useLoadOrderSaleTypeByUser() {
  return useQuery(['orderSaleTypeByUser'], () => loadOrderSaleType(), {
    onError: () =>
      toast.error('Não foi possível carregar tipos de venda!', {
        toastId: 'loadPriceListProducts'
      })
  })
}
